<template>
  <section>
      <multiselect
          v-model="typeVal"
          :options="typesPromptList"
          :multiple="multiple"
          :close-on-select="!multiple"
          :show-labels="false"
          :clear-on-select="false"
          :searchable="true"
          @close="closeSelect"
          @select="selectAction"
          @input="onChange"
          @search-change="searchChange"
          @open="open"
          size="sm"
      ></multiselect>
    <b-overlay :show="showOverlay > 0" class="overlay" rounded="sm"></b-overlay>
  </section>
</template>

<script>
    import Multiselect from 'vue-multiselect'

    export default {
      name: "typeSelect",
      props: {
        initTypes: Array,
        typesChange: Function,
        multiple: Boolean
      },
      components: {
        Multiselect
      },
      data() {
        return {
          typesPromptList: [],
          typesList: [],
          sendTimer: null,
          typeSearch: '',
          numberPromptItem: 10,
          isOpen: false,
          showOverlay: 0,
          typeVal: [],
          nameSeparator: '//',
        }
      },
      methods: {
        open: function () {
          this.isOpen = true
        },
        onChange: function () {
          console.log('onChange')
          if (!this.isOpen) {
            this.returnValue()
          }
        },
        closeSelect: function () {
          console.log('closeSelect')
          this.isOpen = false
          this.returnValue()
        },
        returnValue: function () {
          this.typesChange(this.getTypeDataByName(this.typeVal))
        },
        selectAction: function (name) {
          console.log('selectAction')
          console.log(name)

          this.typeSearch = name
        },
        searchChange: function (searchQuery) {
          console.log('searchChange')
          console.log(searchQuery)
          if (searchQuery.length < 2) {
            return
          }
          if (this.sendTimer != null) {
            clearTimeout(this.sendTimer);
          }
          this.sendTimer = setTimeout(() => {this.sendRequest(searchQuery)}, 1000);
        },
        sendRequest: function (searchQuery) {
          this.showOverlay ++
          this.$store.dispatch('SEND_GET', {
            url: '/type-name?name='+ searchQuery +'&limit='+
                this.numberPromptItem,
            th: this,
            getSuccessResponse: (data) => {
              this.typesPromptList = this.getOnlyNames(data.data)
              this.typesList = data.data
              this.typesList = this.typesList.concat(this.initTypes)
            },
            getResponse: () => {
              this.showOverlay --;
            },
            showSuccessMessage: false
          })
        },
        getTypeDataByName: function (name)
        {
          if (Array.isArray(name)) {
            if (name[0] == 'Все' ) {
              return name
            }

            let result = []
            for (let key in this.typesList) {
              if (
                  this.typesList[key] !== undefined
                  && name.includes(this.typesList[key].name)
                  && !result.includes(this.typesList[key])
              ) {
                let include = false
                for (let key2 in result) {
                  if (result[key2].id == this.typesList[key].id) {
                    include = true
                  }
                }
                if (!include) {
                  result.push(this.typesList[key])
                }
              }
            }

            return result
          } else  {
            let nameArray = name.split(this.nameSeparator)
            for (let nameKey in nameArray) {
              name = nameArray[nameKey].trim()
              for (let key in this.typesList) {
                if (this.typesList[key] === undefined) {
                  continue
                }
                let names = this.typesList[key].name
                for (let keyName in names) {
                  if (name === names[keyName].trim()) {
                    return this.typesList[key]
                  }
                }
              }
            }
          }
        },
        getOnlyNames: function (date) {
          if (date == null || date[0] == null) {
            return []
          }
          if (date[0] == 'Все') {
            return date
          }
          let nameList = []
          for (let key in date) {
            let names = []
            for (let key2 in date[key].name) {
              if (date[key].name[key2] !== "" && date[key].name[key2] !== null) {
                names.push(date[key].name[key2])
              }
            }
            nameList.push(names.join('  //  '))
          }
          return nameList
        },
      },
      computed: {
        getInitData: function () {
          return this.getOnlyNames(this.initTypes)
        }
      },
      mounted() {
      },
      created() {
        this.typeVal = this.getInitData
        this.typesList = this.initTypes
      },
    }
</script>

<style scoped>
  .overlay {
    z-index: 51;
  }
</style>